import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.l6u_1 = partyId;
        this.m6u_1 = pairingSetId;
        this.n6u_1 = date;
        this.o6u_1 = pairs;
        this.p6u_1 = discordMessageId;
        this.q6u_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.l6u_1.toString() + ', pairingSetId=' + this.m6u_1.toString() + ', date=' + this.n6u_1.toString() + ', pairs=' + toString(this.o6u_1) + ', discordMessageId=' + toString(this.p6u_1) + ', slackMessageId=' + toString(this.q6u_1) + ')';
      }
      hashCode() {
        var result = this.l6u_1.hashCode();
        result = imul(result, 31) + this.m6u_1.hashCode() | 0;
        result = imul(result, 31) + this.n6u_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.o6u_1) | 0;
        result = imul(result, 31) + hashCode(this.p6u_1) | 0;
        result = imul(result, 31) + hashCode(this.q6u_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.l6u_1.equals(other.l6u_1))
          return false;
        if (!this.m6u_1.equals(other.m6u_1))
          return false;
        if (!this.n6u_1.equals(other.n6u_1))
          return false;
        if (!equals(this.o6u_1, other.o6u_1))
          return false;
        if (!equals(this.p6u_1, other.p6u_1))
          return false;
        if (!equals(this.q6u_1, other.q6u_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
